//components
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
} from '@/components/PageSection';

//styles
import { FAQLayout, FAQList } from './FAQ.styles';

export function FAQ({ content }) {
  return (
    <PageSection $off>
      <PageSectionInner>
        <FAQLayout>
          <PageSectionTitle>{content.title}</PageSectionTitle>
          <FAQList>
            {content.items.map((item, index) => (
              <details key={`faq-${item.question}`} open={index === 0}>
                <summary>
                  <h3>{item.question}</h3>
                </summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </FAQList>
        </FAQLayout>
      </PageSectionInner>
    </PageSection>
  );
}
